<clr-modal
  #logModal
  (clrModalOpenChange)="omazsid.set(null)"
  [clrModalOpen]="true"
  [clrModalSize]="'lg'"
  [clrModalStaticBackdrop]="false">
  <h3 class="modal-title">{{ 'Mangel-Log' | mrTranslate }}</h3>
  <div class="modal-body">
    @if (log(); as logTable) {
      <clr-datagrid class="datagrid-compact">
        <clr-dg-column clrDgField="LogTyp">
          <ng-container *clrDgHideableColumn="{ hidden: false }">
            {{ 'Aktion' | mrTranslate }}
          </ng-container>
        </clr-dg-column>
        <clr-dg-column clrDgField="AuftragNr">
          <ng-container *clrDgHideableColumn="{ hidden: false }">{{ 'Auftrag' | mrTranslate }} №</ng-container>
        </clr-dg-column>
        <clr-dg-column clrDgField="UserName">
          <ng-container *clrDgHideableColumn="{ hidden: false }">
            {{ 'Username' | mrTranslate }}
          </ng-container>
        </clr-dg-column>
        <clr-dg-column clrDgField="Status">
          <ng-container *clrDgHideableColumn="{ hidden: false }">
            {{ 'Status' | mrTranslate }}
          </ng-container>
        </clr-dg-column>

        <clr-dg-row *clrDgItems="let row of logTable.rows">
          <clr-dg-cell class="name-cell">{{ row.LogTyp | mrTranslate }}</clr-dg-cell>
          <clr-dg-cell class="name-cell">{{ row.AuftragNr || '-' }}</clr-dg-cell>
          <clr-dg-cell class="name-cell">{{ row.UserName }}</clr-dg-cell>
          <clr-dg-cell class="name-cell">{{ row.Status | tablePrettyPrint }}</clr-dg-cell>
        </clr-dg-row>
        <clr-dg-footer>{{ logTable.rows?.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
      </clr-datagrid>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="logModal.close()">
      {{ 'Schließen' | mrTranslate }}
    </button>
  </div>
</clr-modal>
